import React from 'react'
import { SEO } from '../../components/Seo/seo'
import { editProfile } from '../../utils/pages-meta.json'
import EditProfileContent from '../../components/EditProfile'
import { AuthenticatedUserConsumer } from '../../AuthenticatedUserContext'
import { useIntl } from 'react-intl'
import Layout from '../../components/Dashboard/Layout/Layout'
import { FormLoader } from '../../components/Loader/FormLoader'
import { Redirect } from 'react-router-dom'
import { NamedRoutes } from '../../routes'

const EditProfile = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'PageTitle.ProfileEdit' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={editProfile.image}
           description={intl.formatMessage({ id: 'PageTitle.ProfileEdit' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, getCountries }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ?
                <Layout content={<EditProfileContent getCountries={getCountries}/>}/>:
                (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default EditProfile
